'use client';

import {Clock, CoinsIcon, Layers, TrendingUp} from 'lucide-react';
import type {InterviewGuideData} from 'iq-interview_guides/types';

import {Metric} from 'iq-interview_guides/components/metric';

type MetricsProps = Pick<
  InterviewGuideData['data'],
  | 'min_base_salary'
  | 'max_base_salary'
  | 'total_comp'
  | 'interview_rounds'
  | 'interview_process_length'
>;

function formatSalary(n: number): string {
  return `$${Math.round(n / 1000)}K`;
}

export function Metrics({
  min_base_salary,
  max_base_salary,
  total_comp,
  interview_rounds,
  interview_process_length,
}: MetricsProps) {
  const hasBaseComp = min_base_salary != null && max_base_salary != null;
  const hasTotalComp = total_comp != null;
  const visibleCount = 2 + (hasBaseComp ? 1 : 0) + (hasTotalComp ? 1 : 0);
  const gridColsClass = visibleCount === 4 ? 'grid-cols-4' : visibleCount === 3 ? 'grid-cols-3' : 'grid-cols-2';

  return (
    <div
      className={`grid ${gridColsClass} gap-12 mt-8 max-w-[800] w-full max-[660px]:grid-cols-2 max-[660px]:gap-x-4 max-[660px]:gap-y-4`}>
      {hasBaseComp && (
        <Metric
          icon={CoinsIcon}
          value={formatSalary((min_base_salary + max_base_salary) / 2)}
          label='Avg. Base Comp'
        />
      )}
      {hasTotalComp && (
        <Metric icon={TrendingUp} value={formatSalary(total_comp)} label='Avg. Total Comp' />
      )}
      <Metric icon={Layers} value={interview_rounds} label='Typical Rounds' />
      <Metric icon={Clock} value={interview_process_length} label='Process Length' />
    </div>
  );
}
